import { initializeFrontendInstrumentation } from '@spoiler-alert/frontend-instrumentation';
import React, { Component } from 'react';
import { render } from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'mobx-react';
import { JssProvider, ThemeProvider } from 'react-jss';
import FullStory from 'react-fullstory';
import 'whatwg-fetch';
import client from './apollo/client';
import stackdriverErrorReporter from './logging/stackdriver-error-reporter';
import SiteContext from './site-context';
import { Store, Breadcrumbs, UserFilters } from './store';
import AppSettings from './app-settings';
import Tracking from './utilities/tracking-apis';
import { Theme } from '@spoiler-alert/ui-library';

if (AppSettings.OTEL_ENABLED) {
  initializeFrontendInstrumentation({
    serviceName: 'admin-panel',
    serviceVersion: AppSettings.SERVICE_VERSION,
    environment: AppSettings.ENVIRONMENT_NAME,
    ingestionKey: AppSettings.SIGNOZ_TOKEN,
  });
}

Tracking.Initialize();

let classIdNum = 0;
const generateClassNames = (rule, sheet) => {
  classIdNum += 1;
  const componentName = sheet.options.meta
    .split(',')[0]
    .replace(/Apollo\((.+)\)/, '$1')
    .replace(/inject-with-\w+Store\((\w+)\)/, '$1') // For components using OLD mobx pattern. Replace inject('NAME') with inject((store) => store) variant
    .replace(/inject\((\w+)\)/, '$1'); // For components using NEW mobx pattern. (The functional variant of `inject`. See docs for more info.)
  return `${componentName}-${rule.key}-${classIdNum}`;
};

export default class App extends Component {
  render() {
    stackdriverErrorReporter.start();
    return (
      <ApolloProvider client={client}>
        <ThemeProvider theme={Theme}>
          <SiteContext />
          {AppSettings.FULLSTORY_ORG_ID && <FullStory org={AppSettings.FULLSTORY_ORG_ID} />}
        </ThemeProvider>
      </ApolloProvider>
    );
  }
}

render(
  <Provider rootStore={Store} breadcrumbsStore={Breadcrumbs} userFiltersStore={UserFilters}>
    <JssProvider generateId={generateClassNames}>
      <App />
    </JssProvider>
  </Provider>,
  document.getElementById('app'),
);
